import React, { useMemo } from 'react';

const AirlineLogo = ({ companyName }) => {
    const logos = useMemo(() => ({
        Ryanair: '/airlinesLogo/ryanair.png',
        easyJet: '/airlinesLogo/easyjet.png',
        Wizz_Air: '/airlinesLogo/Wizz_Air.png',
    }), []);

    const logoSrc = logos[companyName] || '/airlinesLogo/default.png';

    return <img src={logoSrc} alt={`${companyName} Logo`} className="w-full h-auto rounded-lg" loading="lazy" />;
};

export default AirlineLogo;
